import { TYPE_PROMOTION } from "../enums";

type OrderShowModalReturn = {
  id: number;
  modal: string;
};

export const orderShowModal: OrderShowModalReturn[] = [
  {
    id: 1,
    modal: TYPE_PROMOTION.AVISO_MFA,
  },
  {
    id: 2,
    modal: TYPE_PROMOTION.NPS,
  },
  {
    id: 3,
    modal: TYPE_PROMOTION.NOVA_FORMA_ACESSO_BOLETO,
  },
  {
    id: 4,
    modal: TYPE_PROMOTION.PESQUISA_USABILIDADE,
  },
  {
    id: 5,
    modal: TYPE_PROMOTION.INCENTIVO_BOLETO_DIGITAL,
  },
];
